import { SelectOption } from "Components/molecule/inputs/select-input"

interface DepartmentLike {
    id: string
    description: string
}

// "PP - Calgary Engineering" -> "Calgary Engineering" (company prefixes PP / MPP)
export const stripDepartmentPrefix = (name: string | null | undefined): string =>
    (name ?? "").replace(/^\s*M?PP\s*-\s*/i, "").trim()

export const compareText = (a: string, b: string) =>
    a.localeCompare(b, "en-CA", { sensitivity: "base", numeric: true })

// Department filter options, always A-Z. stripPrefix shows names without "PP - " / "MPP - ".
export const toDepartmentOptions = (
    departments: DepartmentLike[],
    { stripPrefix = false }: { stripPrefix?: boolean } = {},
): SelectOption[] =>
    departments
        .map(d => ({ value: d.id, label: stripPrefix ? stripDepartmentPrefix(d.description) : d.description }))
        .sort((a, b) => compareText(a.label, b.label))
